/*eslint no-prototype-builtins: "off"*/
import * as React from 'react'
import cx from 'classnames'
import * as styles from './account.filter.styl'
import RadioButton from '@src/components/common/radio.button'
import type { FilterOption } from '../../models'
import type { FilterAccount } from '@src/redux/reducers/filter/default.state'

export interface AccountOptionProps {
  data: FilterOption
  isParent: boolean
  logo: string
  selectedAccount: FilterAccount
  onChange: (
    account: FilterOption,
    e: React.ChangeEvent<HTMLInputElement>
  ) => void
}

const AccountOption: React.FC<AccountOptionProps> = ({
  data,
  isParent,
  logo,
  selectedAccount,
  children,
  onChange
}: React.PropsWithChildren<AccountOptionProps>) => {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    onChange(data, event)
  }
  const { name, id, isOrganization } = data || {}

  const role = isOrganization ? 'organization' : 'account'

  return (
    <div
      role={role}
      data-id={id}
      className={cx(styles.optionAccount, { [styles.isParent]: isParent })}
    >
      <RadioButton
        className={styles.radioButtonAccount}
        name="account"
        onChange={handleChange}
        value={id}
        checked={selectedAccount?.id === id}
        label={
          <span role="account_info" className={styles.account}>
            <span role={'name'} className={styles.label}>
              {name}
            </span>
            <span>
              {logo && (
                <img role={'logo'} className={cx(styles.logo)} src={logo} />
              )}
            </span>
          </span>
        }
      />
      {children}
    </div>
  )
}

export default AccountOption
